export function versionMatches(itemVersion: string, appVersion: string): boolean {
  const isMax = itemVersion.endsWith('-');
  const norm = itemVersion.replace(/-$/, '');
  const [iM, iN, iP] = norm.split('.').map(Number);
  const [aM, aN, aP] = appVersion.split('.').map(Number);

  if (isMax) {
    if (aM < iM) return true;
    if (aM > iM) return false;
    if (aN < iN) return true;
    if (aN > iN) return false;
    return aP <= iP;
  } else {
    return appVersion === itemVersion;
  }
}
